import { render, staticRenderFns } from "./TournamentStopped.vue?vue&type=template&id=e7f1435e&scoped=true"
import script from "./TournamentStopped.vue?vue&type=script&lang=js"
export * from "./TournamentStopped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f1435e",
  null
  
)

export default component.exports